import { mockDataUtil } from './mockDataUtil';
import { itemList } from '../mock/itemData';
import { API_ENDPOINTS } from '../utils/apiEndpoints';
import httpClient from './httpClient';
import { ApiResponse } from '../types/item-store-relationship';
import { Item } from '../types/item';
import { WHOLE_USE_MOCK } from './api';

class ItemService {
  
  async getMock(): Promise<boolean> {
    return true;
  }

  /**
   * 获取商品下拉列表
   * @param searchStr 搜索关键词（商品代码或名称）
   * {searchStr, divisionCode, subClassSet}
   * @returns 商品列表
   */
  async listItems(searchReq): Promise<ApiResponse<Item[]>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      // 处理空搜索字符串的情况
      const searchStr = searchReq?.searchStr || '';
      const result = itemList.filter(item => 
        item.code.toLowerCase().includes(searchStr.toLowerCase()) || 
        item.name.toLowerCase().includes(searchStr.toLowerCase())
      );
      const response = await mockDataUtil.mockRes(result);
      return response as unknown as ApiResponse<Item[]>;
    } else {
      const res = await httpClient.post(API_ENDPOINTS.ITEM.LIST, searchReq);
      return res.data;
    }
  }

  /**
   * 根据商品代码获取商品详情
   * @param itemCode 商品代码
   * @returns 商品详情
   */
  async getItemByCode(itemCode: string): Promise<ApiResponse<Item>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      const item = itemList.find(item => item.code === itemCode);
      const response = await mockDataUtil.mockRes(item || null);
      return response as unknown as ApiResponse<Item>;
    } else {
      const res = await httpClient.get(API_ENDPOINTS.ITEM.DETAIL + "?code" + itemCode);
      return res.data;
    }
  }

  /**
   * 获取所有商品列表（分页）
   * @param searchParams 搜索参数
   * @returns 分页商品列表
   */
  async getItems(searchParams: {
    currentPage: number;
    pageSize: number;
    search?: string;
    category?: string;
    status?: string;
  }): Promise<ApiResponse<{ tableData: Item[]; paging: { currentPage: number; totalCount: number; pageSize: number } }>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      let filteredItems = [...itemList];
      
      // 搜索过滤
      if (searchParams.search) {
        filteredItems = filteredItems.filter(item =>
          item.code.toLowerCase().includes(searchParams.search!.toLowerCase()) ||
          item.name.toLowerCase().includes(searchParams.search!.toLowerCase())
        );
      }
      
      // 分类过滤
      if (searchParams.category) {
        filteredItems = filteredItems.filter(item => item.category === searchParams.category);
      }
      
      // 状态过滤
      if (searchParams.status) {
        filteredItems = filteredItems.filter(item => item.status === searchParams.status);
      }

      const response = await mockDataUtil.mockPageRes(filteredItems, {
        currentPage: searchParams.currentPage,
        totalCount: filteredItems.length,
        pageSize: searchParams.pageSize
      });
      return response as unknown as ApiResponse<{ tableData: Item[]; paging: { currentPage: number; totalCount: number; pageSize: number } }>;
    } else {
      const res = await httpClient.post(API_ENDPOINTS.ITEM.PAGE, searchParams);
      return res.data;
    }
  }
}

export const itemService = new ItemService();